<div id="statusFilterLegend" #statusFilterLegend
  [ngClass]="{use_narrow_triggers: viewModel.isSmallViewport}"
  *ngrxLet="viewModel$; let viewModel">
  @for (filter of viewModel.orderedFilterConfig; track filter;) {
    <div
      [matTooltip]="viewModel.isSmallViewport ? filter.translation : ''"
      [ngClass]="{ 'statusFilterContainer': true,
                   'activeStatusFilter': viewModel.filterModel?.status?.includes(filter.id) }"
      (click)="toggleStatusFilter(viewModel.filterModel, filter.id)">
      <p [class]="filter.locationCountClass">{{ viewModel.bubbles[filter.id] }}</p>
      <p class="statusFilterName">{{ filter.translation }}</p>
    </div>
  }
</div>